import styled from "styled-components";
import { motion } from "framer-motion";
import { rgba, media } from "../styles/stylesTheme";
import { getColor, borderRadius } from "../styles/stylesUtils";
import { getCSSImageUrl } from "../utils/mediaUrl";

export const Logo = styled(motion.div)`
    width: auto;
    width: 8em;
    position: fixed;
    left: 10em;
    -webkit-transform: translate(-50%, 0);
    top: 0.3em;
    z-index: 11000;
    font-size: 96%;
    padding-top: 0.7em;
    cursor: pointer;

    &:after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 130%;
        height: 130%;
        transform: translate(-50%, -50%);
        z-index: -2;
        pointer-events: none;
        background: ${getColor("gradL", 0.4)};
        backdrop-filter: blur(0.7em);
        -webkit-backdrop-filter: blur(0.7em);
        mask-image: radial-gradient(
            ellipse 100% 60%,
            white 30%,
            transparent 50%
        );
        -webkit-mask-image: radial-gradient(
            ellipse 100% 60%,
            white 20%,
            transparent 70%
        );
        ${borderRadius(5)}
    }

    > img {
        width: 100%;
        z-index: -1;
        opacity: 0;
        pointer-events: none;
    }

    &:before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: ${(props) => getColor("colorAccent", 1)(props)};
        width: 100%;
        height: 100%;
        mask: url("${getCSSImageUrl("img/logo.svg")}") no-repeat center /
            contain;
        -webkit-mask: url("${getCSSImageUrl("img/logo.svg")}") no-repeat center /
            contain;
        mask-size: 60%;
        -webkit-mask-size: 60%;
    }

    ${media.tablet} {
        top: 1.6em;
        width: 5em;
        left: 2em;
        transform: none;
        pointer-events: none;

        &:before {
            mask: url("${getCSSImageUrl("img/logo.svg")}") no-repeat center /
                contain;
            -webkit-mask: url("${getCSSImageUrl("img/logo.svg")}") no-repeat
                center / contain;
            mask-size: 100%;
            -webkit-mask-size: 100%;
            width: 5em;
        }

        &:after {
            width: 60%;
        }
    }
`;

export const FloatingSettingsButton = styled(motion.button)`
    position: fixed;
    top: 2.2em;
    left: 2.2em;
    z-index: 80000;
    border: none;
    ${borderRadius(0.5)}
    cursor: pointer;
    background: ${getColor("colorUI", 0.7)};
    backdrop-filter: blur(1em);
    -webkit-backdrop-filter: blur(1em);
    opacity: 1;
    height: 3em;
    box-sizing: border-box;
    padding: 0;
    overflow: hidden;
    font-size: 1em;

    &:before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        z-index: 1;
        box-shadow: inset 0 -0.05em 0.1em 0 ${getColor("colorAccent", 0.1)},
            inset 0 0.05em 0.1em 0 ${getColor("colorAI", 1)};
        ${borderRadius(0.5)}
    }

    > div {
        display: inline-block;
        position: relative;
        height: 3em;
        top: 0;
        vertical-align: top;
        box-sizing: border-box;

        &:nth-child(1) {
            background: ${getColor("colorUI", 1, 3)};
            padding: 0.2em;
            width: 4.4em;
            position: relative;

            &:before {
                content: "";
                position: absolute;
                left: 50%;
                top: 51%;
                transform: translateX(-50%) translateY(-50%);
                width: 1.6em;
                height: 1.6em;
                background: ${getColor("black", 0.8)};
                mask: url("${getCSSImageUrl("img/icon-account.svg")}") no-repeat
                    center / contain;
                -webkit-mask: url("${getCSSImageUrl("img/icon-account.svg")}")
                    no-repeat center / contain;
            }
        }

        &:nth-child(2) {
            width: 4.4em;
            position: relative;

            &:before {
                content: "";
                position: absolute;
                left: 50%;
                top: 51%;
                transform: translateX(-50%) translateY(-50%);
                width: 1.8em;
                height: 1em;
                background: ${getColor("black", 1)};
                opacity: 0.7;
                mask: url("${getCSSImageUrl("img/settings.svg")}") no-repeat
                    center / contain;
                -webkit-mask: url("${getCSSImageUrl("img/settings.svg")}")
                    no-repeat center / contain;
            }
        }
    }

    &:hover {
        > div {
            &:nth-child(1) {
                &:before {
                    opacity: 1;
                }
            }
        }
    }

    ${media.tablet} {
        font-size: 1.2em;
        top: 1.4em;
        left: 1.4em;
    }

    ${media.mobile} {
        font-size: 1em;
        top: 2em;
        left: 2em;
    }
`;

export const NavbarContainer = styled(motion.div)`
    position: fixed;
    top: 8em;
    left: 2.8em;
    width: 15em;
    z-index: 70000;
    font-size: 0.9em;
    text-align: center;
    box-sizing: border-box;

    ${media.tablet} {
        font-size: 1.6em;
        left: 1.4em;
        top: 4.7em;
        width: calc(100% - 2.8em);
    }
`;

export const FloatingMenuButton = styled(motion.button)`
    display: none;
    position: fixed;
    top: 2.2em;
    left: 2.2em;
    z-index: 80000;
    border: none;
    ${borderRadius(0.5)}
    cursor: pointer;
    background: ${getColor("colorUI", 0.7)};
    backdrop-filter: blur(1em);
    -webkit-backdrop-filter: blur(1em);
    height: 3em;
    width: 3em;
    box-sizing: border-box;
    padding: 0;
    overflow: hidden;

    &:before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        z-index: 1;
        box-shadow: inset 0 -0.05em 0.1em 0 ${getColor("colorAccent", 0.1)},
            inset 0 0.05em 0.1em 0 ${getColor("colorAI", 1)};
        ${borderRadius(0.5)}
    }

    &:after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1.2em;
        height: 0.25em;
        background: ${getColor("black", 0.7)};
        mask: url("${getCSSImageUrl("img/settings.svg")}") no-repeat center /
            contain;
        -webkit-mask: url("${getCSSImageUrl("img/settings.svg")}") no-repeat
            center / contain;
    }

    &:hover {
        opacity: 0.85;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }

    ${media.tablet} {
        display: block;
        font-size: 1.2em;
        top: 1.4em;
        left: 7em;
    }

    ${media.mobile} {
        font-size: 1em;
        top: 2em;
        left: 7.8em;
    }
`;

export const NavButton = styled.button`
    margin: 0.4em;
    padding: 0.8em 0.8em 0.9em;
    background: ${(props) => getColor("colorUI", 1)(props)};
    color: ${(props) => getColor("black", 1)(props)};
    border: none;
    ${borderRadius(0.5)}
    cursor: pointer;
    transition: 0.15s;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 0.8em);
    font-size: 1em;
    opacity: 1;
    height: 3em;
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(1em);
    -webkit-backdrop-filter: blur(1em);
    user-select: none;
    -webkit-user-select: none;
    font-family: var(--bold);

    &:after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        z-index: 1;
        box-shadow: inset 0 -0.05em 0.1em 0 ${getColor("colorAccent", 0.1)},
            inset 0 0.05em 0.1em 0 ${getColor("colorAI", 1)};
        ${borderRadius(0.5)}
    }

    &:hover {
        opacity: 0.85;
    }

    &.settings {
        width: calc(50% - 0.8em);

        &:before {
            content: "";
            position: absolute;
            left: 50%;
            top: 51%;
            transform: translateX(-50%) translateY(-50%);
            width: 2em;
            height: 2em;
            background: ${getColor("black", 1)};
            mask: url("${getCSSImageUrl("img/icon-account.svg")}") no-repeat
                center / contain;
            -webkit-mask: url("${getCSSImageUrl("img/icon-account.svg")}")
                no-repeat center / contain;
        }
    }

    &.logout {
        opacity: 0.5;
        margin-top: 1em !important;

        &:hover {
            opacity: 0.7;
        }
    }

    &.send-feedback {
        background: ${getColor("colorUI", 0.3)} !important;
        color: ${getColor("black", 1)} !important;
        box-shadow: none !important;
        padding-left: 2.4em;

        .icon {
            position: absolute;
            left: 0.8em;
            top: 50%;
            transform: translateY(-50%);
            width: 1.1em;
            height: 1.2em;
            background: ${getColor("black", 0.7)} !important;
            mask: url("${getCSSImageUrl("img/icon-chatText.svg")}") no-repeat
                center / contain;
            -webkit-mask: url("${getCSSImageUrl("img/icon-chatText.svg")}")
                no-repeat center / contain;
        }

        &:hover {
            opacity: 1 !important;
        }
    }

    &.manage-subscription {
        background: ${getColor("colorUI", 0.3)} !important;
        color: ${getColor("black", 1)} !important;
        box-shadow: none !important;
        padding-left: 2.4em;

        .icon {
            position: absolute;
            left: 0.8em;
            top: 50%;
            transform: translateY(-50%);
            width: 1.1em;
            height: 1.2em;
            background: ${getColor("black", 0.7)} !important;
            mask: url("${getCSSImageUrl("img/icon-account.svg")}") no-repeat
                center / contain;
            -webkit-mask: url("${getCSSImageUrl("img/icon-account.svg")}")
                no-repeat center / contain;
        }

        &:hover {
            opacity: 1 !important;
        }
    }
`;

export const SettingsContainer = styled(motion.div)`
    position: fixed;
    top: 5.2em;
    left: 19.2em;
    width: 18em;
    z-index: 10000;
    background: ${getColor("colorUI", 0.7)};
    ${borderRadius(0.7)}
    padding: 1em;
    box-shadow: 0 0.1em 0.5em 0 ${getColor("black", 0.12)};
    font-size: 96%;
    backdrop-filter: blur(3em);
    -webkit-backdrop-filter: blur(3em);

    h3 {
        display: block;
        text-align: center;
        font-size: 0.9em;
        color: ${getColor("black", 0.6)};
        margin: 0;
        padding: 0.3em 0 0.2em;
        width: 100%;
        font-weight: normal;

        &.user-name {
            font-size: 1.1em;
            color: ${getColor("black", 0.9)};
            margin-bottom: 0.5em;
        }
    }

    > button {
        margin: 0.6em auto;
        margin-top: 0;
        width: calc(100% - 1.2em);
        max-width: 30em;
    }

    ${media.tablet} {
        position: fixed;
        top: 0;
        left: 0;
        height: 100svh;
        width: 100%;
        box-shadow: none;
        background: transparent;
        padding: 5em 2em 0;
        box-sizing: border-box;
        backdrop-filter: blur(10em);
        -webkit-backdrop-filter: blur(10em);
        background: ${getColor("gradL", 0.5)};
        ${borderRadius(0)}
        overflow-y: auto !important;
        overscroll-behavior: none;
        padding-bottom: 4em;

        h3 {
            margin-left: 0.6em;
            max-width: 30em;
            margin: 0 auto;
        }

        > button {
            background: ${getColor("colorUI", 0.9)};
        }
    }
`;

export const NavBackdrop = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 6999;
`;

export const SettingsCloseButton = styled(motion.button)`
    position: fixed !important;
    width: 3em;
    height: 3em;
    border: none;
    background: none;
    cursor: pointer;
    z-index: 10001;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    background: ${(props) => rgba(props.theme, "black", 0.05)} !important;
    top: 1.6em;
    left: 1.6em;

    &:hover {
        background: ${(props) => rgba(props.theme, "black", 0.07)};
    }

    &:active {
        transform: scale(0.95);
    }

    &::before {
        content: "";
        width: 1.2em;
        height: 1.2em;
        background: ${(props) => rgba(props.theme, "black", 1)};
        mask-image: url("${getCSSImageUrl("img/icon-x.svg")}");
        -webkit-mask-image: url("${getCSSImageUrl("img/icon-x.svg")}");
        mask-position: center;
        -webkit-mask-position: center;
        mask-repeat: no-repeat;
        -webkit-mask-repeat: no-repeat;
        mask-size: contain;
        -webkit-mask-size: contain;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    ${media.mobile} {
        top: 2.4em;
        left: 2.4em;
    }
`;
